/**
 * Hue and icon for each firm register (27 Oct 2026 system-wide refresh, the
 * Bonsai Agents look). Shared by the register list and a register's page. A
 * register added later falls back to indigo and the clipboard. Hues stay off
 * green, amber and red, which mean status.
 */
import {
  Ban, ClipboardCheck, Database, EyeOff, FileSearch, Fingerprint, Gavel, Gift, Globe, GraduationCap,
  Handshake, KeyRound, Landmark, ListChecks, MessageSquareWarning, Radar, Scale, ServerCrash, ShieldAlert,
  Telescope, UserCheck, UserSearch,
} from "lucide-react";

const LOOK = {
  "REG-01": [MessageSquareWarning, "#ec4899", "#a855f7"],
  "REG-02": [Scale, "#6366f1", "#a855f7"],
  "REG-03": [Ban, "#8b5cf6", "#ec4899"],
  "REG-04": [ShieldAlert, "#d946ef", "#6366f1"],
  "REG-04b": [ServerCrash, "#3b82f6", "#8b5cf6"],
  "REG-05": [Handshake, "#0ea5e9", "#6366f1"],
  "REG-06": [Radar, "#a855f7", "#ec4899"],
  "REG-07": [Gift, "#ec4899", "#d946ef"],
  "REG-08": [GraduationCap, "#6366f1", "#0ea5e9"],
  "REG-09": [KeyRound, "#8b5cf6", "#3b82f6"],
  "REG-10": [FileSearch, "#06b6d4", "#6366f1"],
  "REG-11": [UserSearch, "#3b82f6", "#a855f7"],
  "REG-12": [EyeOff, "#6366f1", "#d946ef"],
  "REG-13": [Database, "#0ea5e9", "#8b5cf6"],
  "REG-16": [Fingerprint, "#a855f7", "#6366f1"],
  "REG-17": [Gavel, "#6366f1", "#ec4899"],
  "REG-18": [Landmark, "#3b82f6", "#6366f1"],
  "REG-19": [UserCheck, "#d946ef", "#a855f7"],
  "REG-20": [Globe, "#06b6d4", "#3b82f6"],
  "REG-21": [ListChecks, "#8b5cf6", "#ec4899"],
  "REG-22": [Telescope, "#0ea5e9", "#a855f7"],
};
const FALLBACK = [ClipboardCheck, "#6366f1", "#a855f7"];

export function registerLook(ref) {
  const [Icon, c1, c2] = LOOK[ref] || FALLBACK;
  return { Icon, c1, c2, style: { "--c1": c1, "--c2": c2 } };
}
